export interface TokenSearch {
  token?: string;
}

export function tokenSearch(search: Record<string, unknown>): TokenSearch {
  const token = search.token;
  return typeof token === "string" && token !== "" ? { token } : {};
}
